export default {"src":"/planos/_next/static/media/equifax-info.d0853a47.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};